import api from "services/api";
import pathnames from "routes/pathnames";

export const NOTIFICATION_REFERENCE_PARAM = "notificationRefId";

export const NOTIFICATION_PAGE_KIND = {
	LEAVE_APPROVAL: "LEAVE_APPROVAL",
	LEAVE_HISTORY: "LEAVE_HISTORY",
	CLAIM_APPROVAL: "CLAIM_APPROVAL",
	CLAIM_HISTORY: "CLAIM_HISTORY",
	APPOINTMENT: "APPOINTMENT",
	EMPLOYEE_PROFILE: "EMPLOYEE_PROFILE",
	OVERTIME_APPROVAL: "OVERTIME_APPROVAL",
};

const NOTIFICATION_TYPE_PAGE_KIND = {
	CREATE_LEAVE: NOTIFICATION_PAGE_KIND.LEAVE_APPROVAL,
	ADMIN_EMPLOYEE_CANCEL_LEAVE: NOTIFICATION_PAGE_KIND.LEAVE_HISTORY,
	ADMIN_REPORTING_MANAGER_CANCEL_LEAVE: NOTIFICATION_PAGE_KIND.LEAVE_HISTORY,
	ADMIN_REPORTING_MANAGER_UPDATE_LEAVE_STATUS: NOTIFICATION_PAGE_KIND.LEAVE_HISTORY,
	ADMIN_REPORTING_MANAGER_UPDATE_OVERTIME_COMPENSATION_STATUS: NOTIFICATION_PAGE_KIND.OVERTIME_APPROVAL,
	CREATE_CLAIM: NOTIFICATION_PAGE_KIND.CLAIM_APPROVAL,
	CANCEL_CLAIM: NOTIFICATION_PAGE_KIND.CLAIM_HISTORY,
	ACKNOWLEDGE_APPOINTMENT: NOTIFICATION_PAGE_KIND.APPOINTMENT,
	UPDATE_PERSONAL_INFO: NOTIFICATION_PAGE_KIND.EMPLOYEE_PROFILE,
};

const isEmptyReference = (referenceId) => referenceId === null || referenceId === undefined || referenceId === "";

const withReference = (pathname) => (referenceId) => {
	if (isEmptyReference(referenceId)) return null;

	const search = new URLSearchParams({ [NOTIFICATION_REFERENCE_PARAM]: referenceId });

	return `${pathname}?${search.toString()}`;
};

const employeeProfileRoute = async (referenceId) => {
	if (isEmptyReference(referenceId)) return null;

	const response = await api.get.employee.detailEmail({ id: referenceId });

	const email = typeof response === "string" ? response : response?.email;

	if (!email) return null;

	const search = new URLSearchParams({ tab: "Personal Info" });

	return `${pathnames.userManagement.employee}${encodeURIComponent(email)}?${search.toString()}`;
};

const NOTIFICATION_PAGE_KIND_ROUTE = {
	[NOTIFICATION_PAGE_KIND.LEAVE_APPROVAL]: withReference(pathnames.leaveManagement.leavesApproval),
	[NOTIFICATION_PAGE_KIND.LEAVE_HISTORY]: withReference(pathnames.leaveManagement.allLeave),
	[NOTIFICATION_PAGE_KIND.CLAIM_APPROVAL]: withReference(pathnames.claimManagement.claimApproval),
	[NOTIFICATION_PAGE_KIND.CLAIM_HISTORY]: withReference(pathnames.claimManagement.companyClaimHistory),
	[NOTIFICATION_PAGE_KIND.OVERTIME_APPROVAL]: withReference(pathnames.overtimeManagement.overtimeApproval),
	// no detail view exists for appointments, so it lands on the list page
	[NOTIFICATION_PAGE_KIND.APPOINTMENT]: () => pathnames.appointmentSession.pageAppointmentSession,
	[NOTIFICATION_PAGE_KIND.EMPLOYEE_PROFILE]: employeeProfileRoute,
};

export const hasNotificationRoute = (notificationType) => !!NOTIFICATION_TYPE_PAGE_KIND[notificationType];

const getNotificationRoute = async (notificationType, referenceId) => {
	const pageKind = NOTIFICATION_TYPE_PAGE_KIND[notificationType];

	if (!pageKind) return null;

	const routeBuilder = NOTIFICATION_PAGE_KIND_ROUTE[pageKind];

	if (!routeBuilder) return null;

	const route = await routeBuilder(referenceId);

	return route || null;
};

export default getNotificationRoute;
